<section class="page page-registro">

    <h2 class="page-title">
        <span i18n="@@registro-como-alumno-cmab">Confirmar registro en Alumni CMAB</span>
    </h2>

    <div class="page-body">
        @if (!alumni_ok()) {
        <form [formGroup]="f_data" (ngSubmit)="checkAlumni()">
            <ul>
                <li class="comentario">
                    <h3>
                        <span i18n="@@registro-como-alumno-cmab">Confirmar registro en Alumni CMAB</span>
                    </h3>
                    <span i18n="@@Si_quieres_corfirmar_que_deseas_formar_parte_de_Alumni_CMAB_debes_indicarnos_tu_DNI_y_tu_numero_de_colegiado_personal">Si quieres corfirmar que deseas formar parte de Alumni CMAB, debes indicarnos tu DNI y tu número de colegiado personal</span>
                </li>
                <li>
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@dni">DNI</mat-label>
                        <input matInput formControlName="dni"
                            (focus)="cancelCredenciales()">
                        <mat-error>
                            @if (f_data.get('dni')?.hasError('required') && f_data.get('dni')?.touched) {
                                <span i18n="@@el_DNI_es_requerido">El DNI es requerido</span>
                            }
                        </mat-error>
                    </mat-form-field>
                </li>
                <li>
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@num_colegiado">Número de colegiado</mat-label>
                        <input matInput formControlName="num_colegiado"
                                (focus)="cancelCredenciales()">
                        <mat-error>
                            @if (f_data.get('num_colegiado')?.hasError('required') && f_data.get('num_colegiado')?.touched) {
                                <span i18n="@@el_numero_de_colegiado_es_requerido">El número de colegiado es requerido</span>
                            }
                        </mat-error>
                    </mat-form-field>
                </li>
                <li class="acciones">
                    <button mat-flat-button color="primary" type="button" (click)="cancel()">
                        <span i18n="@@ir_identificacion">Ir a identificación</span>
                    </button>
                    <button type="submit" mat-flat-button [btnLoading]="loading()" color="primary" [disabled]="f_data.invalid">
                        <span i18n="@@confirmo">Confirmo</span>
                    </button>
                </li>
            </ul>
        </form>
        @switch (return_error()) {
        @case (0) {

        }
        @case (1100) {
        <p class="msg-error" i18n="@@se_ha_encontrado_alumno_con_mismo_dni">
            Alumni CMAB se dirige exclusivamente a quienes han cursado el
            Master en Gestión de Empresas de Mediación de Seguros y están
            colegiados a título personal. Si deseas formar parte de esta
            comunidad y todavía no estás colegiado/a, el Col·legi ha previsto
            una modalidad de incorporación especialmente pensada para facilitar
            tu acceso a Alumni CMAB.
        </p>
        <img src="assets/images/no-colegiado-2.png" alt="Contacte con el col·legi">
        }
        @case (1110) {
        <p class="msg-error" i18n="@@se_ha_encontrado_alumno_con_mismo_dni">
            Alumni CMAB se dirige exclusivamente a quienes han cursado el
            Master en Gestión de Empresas de Mediación de Seguros y están
            colegiados a título personal. Si deseas formar parte de esta
            comunidad y todavía no estás colegiado/a, el Col·legi ha previsto
            una modalidad de incorporación especialmente pensada para facilitar
            tu acceso a Alumni CMAB.
        </p>
        <img src="assets/images/no-colegiado-2.png" alt="Contacte con el col·legi">
        }
        @case (1120) {
        <p class="msg-error" i18n="@@el_alumno_ya_esta_registrado">
            El alumno ya está registrado!
        </p>
        }
        @default {
        <p class="msg-error" i18n="@@error_no_controlado">Se a producido un error {{return_error()}} buscando alumno.</p>
        }
        }
        }
        @if (alumni_ok()) {
        <form [formGroup]="f_usuario" (ngSubmit)="registrarUsuario()">
            <ul>
                <li class="comentario">
                    <h3>
                        <span i18n="@@crear-credenciales-de-acceso">Crear credenciales de acceso</span>
                    </h3>
                    <span i18n="@@para_acceder_al_directorio_alumni_cmab_crea_tus_credenciales_de_acceso">Para acceder al directorio Alumni CMAB crea tus credenciales de acceso:</span>
                </li>
                <li>
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@nombre_usuario">Nombre usuario</mat-label>
                        <input matInput formControlName="nombre">
                        <mat-error>
                            @if (f_usuario.get('nombre')?.hasError('required') && f_usuario.get('nombre')?.touched) {
                                El nombre de usuario es requerido
                            } @else if (f_usuario.get('nombre')?.hasError('usuarioNoUnico') && f_usuario.get('nombre')?.touched) {
                                El nombre de usuario {{f_usuario.get('nombre')?.value}} ya existe. Por favor, elija otro.
                            }
                        </mat-error>
                    </mat-form-field>
                </li>
                <li>
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@email">e-Mail</mat-label>
                        <input matInput formControlName="email">
                        <mat-error> 
                            @if (f_usuario.get('email')?.hasError('required') && f_usuario.get('email')?.touched) {
                                El email es requerido
                            } @else if (f_usuario.get('email')?.hasError('email') && f_usuario.get('email')?.touched) {
                                El email no es valido
                            }
                        </mat-error>
                    </mat-form-field>

                </li>
                <li class="comentario">
                    <span i18n="@@para_acceder_al_directorio_alumni_cmab_crea_tu_credenciales_de_acceso">Para acceder al directorio Alumni CMAB crea tu contraseña:</span>
                </li>
                <li formGroupName="password" class="password-container">
                    <!-- Campo Password -->
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@password">Password</mat-label>
                        <input matInput [type]="hidePassword ? 'password' : 'text'" 
                                formControlName="password_1" autocomplete="new-password">
                        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
                            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-error>
                            @if (f_usuario.get('password.password_1')?.hasError('required') &&
                            f_usuario.get('password.password_1')?.touched) {
                                La contraseña es requerida
                            } @else if (f_usuario.get('password.password_1')?.hasError('minlength') &&
                            f_usuario.get('password.password_1')?.touched) {
                                La contraseña debe tener al menos 8 caracteres
                            }
                        </mat-error>
                    </mat-form-field>

                    <!-- Campo Confirmar Password -->
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@password_confirm">Confirmar password</mat-label>
                        <input matInput [type]="hideConfirmPassword ? 'password' : 'text'"
                            formControlName="password_confirm" autocomplete="new-password">
                        <button mat-icon-button matSuffix type="button"
                            (click)="hideConfirmPassword = !hideConfirmPassword">
                            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        @if (f_usuario.get('password.password_confirm')?.hasError('required') &&
                            f_usuario.get('password.password_confirm')?.touched) {
                            <mat-error>
                                Confirmar la contraseña es requerido
                            </mat-error>
                        }
                    </mat-form-field>
                </li>
                <li style="text-align: left;">
                    @if (f_usuario.get('password')?.hasError('passwordMismatch')) {
                        <mat-error>
                            Las contraseñas no coinciden
                        </mat-error>
                    }
                </li>

                <li class="acciones">
                    <button mat-flat-button color="warn" type="button" (click)="cancelCredenciales()">
                        <span i18n="@@cancelar">Cancelar</span>
                    </button>
                    <button mat-flat-button color="primary" type="submit" [disabled]="f_usuario.invalid">
                        <span i18n="@@validar">Validar</span>
                    </button>

                </li>
            </ul>
        </form>
        }
        <div class="error-summary" style="display: none;">
          @for (control of f_usuario.controls | keyvalue; track control.key) {
            <!-- @if (control.value.errors && (control.value.dirty || control.value.touched)) { -->
              <div class="field-errors">
                <strong>Errores en {{ control.key }}:</strong>
                
                <ul>
                  @for (error of control.value.errors | keyvalue; track error.key) {
                    <li>
                      Error: {{ error.key }} 
                      <span>(Detalles: {{ error.value | json }})</span>
                    </li>
                  }
                </ul>
              </div>
            }
          <!-- } -->
        </div>
    </div>
</section>